const Data = [
  {
    id: 1,
    title: 'Rider Concrete',
    description: `Focused on a company's digital presence by creating a SEO-optimized website using the Next.js framework.`,
    framework: 'Next',
    url: 'https://www.riderconcreteandexcavation.com/',
    img: 'https://i.imgur.com/KQTahdv.png'
  },
  {
    
    id: 2,
    title: 'Pokemon TCG Guru',
    description: `A Platform That Helps You Discover The Value Of Your Pokemon
    Cards, And Find And Purchase New Cards With Updated Current And
    Previous Pricing.`,
    framework: 'React',
    url: 'https://tcg.vercel.app/',
    img: 'https://i.imgur.com/xVanUSo.jpg'
  },
  {
    id: 3,
    title: 'Straub Construction',
    description: `Personal construction website focusing on displaying previous body of work, dynamic pricing and summaries, along with pinch and zoom blueprints.`,
    framework: 'React',
    url: 'https://construction-freelance.vercel.app/',
    img: 'https://i.imgur.com/RzTpK3L.jpg'
  }
];

export default Data;